import { useParams } from 'react-router'
import { ObjectTypes } from '../api/object'
import { useTableLayout } from '../layouts'
import { ObjectEditForm } from '../objects/object-edit'
import { ObjectFormInPlace } from '../objects/object-form-in-place'
import { ObjectsTable } from '../objects/objects'
import { ActionBar } from './detail'

export function Detail() {
	const { id = '' } = useParams<{ id: string }>()
	return (
		<>
			<ActionBar id={id} />
			<ObjectFormInPlace object="client" name="in-place" id={id} />
		</>
	)
}

export function Relation() {
	const { id = '', object = '' } = useParams<{ object: keyof ObjectTypes; id: string }>()
	const { layout, isLoading } = useTableLayout(object, 'client', {
		type: 'relation',
	})

	if (!id || !object) return null
	if (isLoading) return null
	if (!layout) return null

	return <ObjectsTable table={layout} object={object} related={{ client_id: id }} />
}

export function RelationEdit() {
	const { id = '', object = '' } = useParams<{ object: keyof ObjectTypes; id: string }>()

	if (!id || !object) return null

	return <ObjectEditForm object={object} id={id} />
}
